import React from 'react';
import { createRoot } from 'react-dom/client';
import { initializeDatadog } from 'utils';
import '@guestyci/arc-styles';

import { AppProvider } from 'components';

initializeDatadog();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<AppProvider />);
